import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { inject, observer } from 'mobx-react';

import Loading from '../Loading';

@inject('LiveDispatchStore', 'UserStore')
@observer
class OutletOpenCloseControl extends Component {
    state = {
        showPauseOutletOptions: false,
        pauseOutletDuration: '',
        pauseOutletCustomHours: '',
        outletControlErrorMessage: '',
    };

    componentDidMount() {
        if (this.isTerritoryManager()) {
            this.loadOutletControlData().catch(() => {
                this.setState({
                    outletControlErrorMessage: 'Unable to load outlet controls right now.',
                });
            });
        }
    }

    isTerritoryManager = () => {
        const {
            UserStore: { position },
        } = this.props;

        return position === 'Territory Manager';
    };

    loadOutletControlData = () => {
        const {
            LiveDispatchStore: {
                handleGetOutletPausedStatus,
            },
        } = this.props;

        return handleGetOutletPausedStatus();
    };

    handlePauseOutletClick = () => {
        this.setState({
            showPauseOutletOptions: true,
            outletControlErrorMessage: '',
        });
    };

    handlePauseDurationChange = (event) => {
        this.setState({
            pauseOutletDuration: event.target.value,
            pauseOutletCustomHours: '',
            outletControlErrorMessage: '',
        });
    };

    handleCustomHoursChange = (event) => {
        this.setState({
            pauseOutletCustomHours: event.target.value,
            outletControlErrorMessage: '',
        });
    };

    getPauseDurationMinutes = () => {
        const { pauseOutletDuration, pauseOutletCustomHours } = this.state;

        switch (pauseOutletDuration) {
        case '30_minutes':
            return 30;
        case '1_hour':
            return 60;
        case 'CUSTOM_HOURS':
            return pauseOutletCustomHours ? Number(pauseOutletCustomHours) * 60 : null;
        case 'rest_of_day': {
            const now = new Date();
            const endOfDay = new Date();
            endOfDay.setHours(23, 59, 59, 999);

            return Math.ceil((endOfDay.getTime() - now.getTime()) / 60000);
        }
        default:
            return null;
        }
    };

    handlePauseOutletSubmit = () => {
        const {
            LiveDispatchStore: { handlePauseOutletTemporarily },
        } = this.props;

        const durationMinutes = this.getPauseDurationMinutes();

        if (!durationMinutes || durationMinutes <= 0) {
            this.setState({
                outletControlErrorMessage: 'Select pause duration first.',
            });
            return;
        }

        handlePauseOutletTemporarily(durationMinutes)
            .then(() => {
                this.setState({
                    showPauseOutletOptions: false,
                    pauseOutletDuration: '',
                    pauseOutletCustomHours: '',
                    outletControlErrorMessage: '',
                });
            })
            .catch(() => {
                this.setState({
                    outletControlErrorMessage: 'Unable to pause outlet right now.',
                });
            });
    };

    handleUnpauseOutlet = () => {
        const {
            LiveDispatchStore: { handleUnpauseOutlet },
        } = this.props;

        handleUnpauseOutlet().catch(() => {
            this.setState({
                outletControlErrorMessage: 'Unable to open outlet right now.',
            });
        });
    };

    render() {
        const {
            showPauseOutletOptions,
            pauseOutletDuration,
            pauseOutletCustomHours,
            outletControlErrorMessage,
        } = this.state;

        const {
            LiveDispatchStore: {
                outletControlLoading,
                outletPaused
            },
        } = this.props;

        if (!this.isTerritoryManager()) {
            return <Redirect to="/packing" />;
        }

        return (
            <div
                style={{
                    minHeight: '100vh',
                    backgroundColor: 'white',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'auto',
                }}
            >
                <Helmet>
                    <title>Outlet Open/Close Control | Outlet OS | Pop Meals</title>
                </Helmet>

                <div className="packing-v2">
                    <div className="packing-v2__outlet-controls">
                        <div className="packing-v2__outlet-controls-body">
                            {outletControlLoading && (
                                <div className="packing-v2__outlet-controls-loader">
                                    <Loading />
                                </div>
                            )}

                            <div className="packing-v2__sale-platform-controls">
                                <button
                                    type="button"
                                    className="packing-v2__outlet-action packing-v2__outlet-action--primary"
                                    onClick={
                                        outletPaused
                                            ? this.handleUnpauseOutlet
                                            : this.handlePauseOutletClick
                                    }
                                    disabled={outletControlLoading}
                                >
                                    {outletPaused ? 'Open outlet' : 'Pause outlet temporarily'}
                                </button>

                                {showPauseOutletOptions && !outletPaused && (
                                    <div className="packing-v2__dine-in-hours-card">
                                        <div className="packing-v2__dine-in-hours-copy">
                                            Select how long this outlet should be paused.
                                        </div>

                                        <select
                                            className="packing-v2__sale-platform-duration"
                                            value={pauseOutletDuration}
                                            onChange={this.handlePauseDurationChange}
                                        >
                                            <option value="">Select duration</option>
                                            <option value="30_minutes">30 minutes</option>
                                            <option value="1_hour">1 hour</option>
                                            <option value="CUSTOM_HOURS">Custom hours</option>
                                            <option value="rest_of_day">Rest of the day</option>
                                        </select>

                                        {pauseOutletDuration === 'CUSTOM_HOURS' && (
                                            <input
                                                type="number"
                                                min="1"
                                                className="packing-v2__dine-in-hours-input"
                                                placeholder="Enter hours"
                                                value={pauseOutletCustomHours}
                                                onChange={this.handleCustomHoursChange}
                                            />
                                        )}
                                       <button
                                            type="button"
                                            className="packing-v2__outlet-action packing-v2__outlet-action--primary"
                                            onClick={this.handlePauseOutletSubmit}
                                            disabled={outletControlLoading}
                                        >
                                            Confirm pause
                                        </button>
                                    </div>
                                )}

                                {outletControlErrorMessage && (
                                    <p className="packing-v2__outlet-error">
                                        {outletControlErrorMessage}
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default OutletOpenCloseControl;